import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import bgSrc from '../../assets/images/reputation-bg.png';
import reputationStatusErrorSrc from '../../assets/images/reputation-status-error.png';
import reputationStatusWarningSrc from '../../assets/images/reputation-status-warning.png';
import reputationStatusSafeSrc from '../../assets/images/reputation-status-safe.png';
import { RISK_STATUS } from '../../../lib/shared/reputation-risk-status';
import styles from './SafetyIndicator.css';

const cx = classnames.bind(styles);

const getData = (status) => {
    if (status === RISK_STATUS.HIGH) {
        return {
            imageUrl: reputationStatusErrorSrc
        }
    }

    if (status === RISK_STATUS.MEDIUM) {
        return {
            imageUrl: reputationStatusWarningSrc
        }
    }

    if (status === RISK_STATUS.LOW) {
        return {
            imageUrl: reputationStatusSafeSrc
        }
    }

    return {};
};

function SafetyIndicator({
    status,
    description,
    className
}) {
    const classes = cx({
        root: true,
        [className]: className,
        [status]: status
    });

    return (
        <div
            className={classes}
            style={{backgroundImage: `url(${bgSrc})`}}
        >
            <img alt='signs' src={getData(status).imageUrl} />
            <span>{description}</span>
        </div>
    );
};

SafetyIndicator.propTypes = {
    className: PropTypes.string,
    status: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

SafetyIndicator.defaultProps = {
    className: ''
};

export {
    SafetyIndicator
};
